module.exports = __webpack_public_path__ + "img/knowledge.9603d75e.svg";